import { render, staticRenderFns } from "./BillingOrderActionPage.vue?vue&type=template&id=70573e96&scoped=true"
import script from "./BillingOrderActionPage.vue?vue&type=script&lang=js"
export * from "./BillingOrderActionPage.vue?vue&type=script&lang=js"
import style0 from "./BillingOrderActionPage.vue?vue&type=style&index=0&id=70573e96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70573e96",
  null
  
)

export default component.exports